import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, Tabs, TabsList, TabsTrigger, TabsContent } from '@pisaka/ui';
import { MODAL_NAME_AUTH } from '../../constants/modalNamesConstants';
import { useModal } from '../../hooks/useModal';
import {
  AuthModalPayloadType, AuthStateType, LOGIN_STATE_TYPE, REGISTER_STATE_TYPE, RESET_PASSWORD_STATE_TYPE
} from './authTypes';
import { LoginContainer } from './login/LoginContainer';
import { RegisterContainer } from './register/RegisterContainer';
import { ResetPasswordContainer } from './resetPassword/ResetPasswordContainer';

const AuthModalContainer: FC = () => {
  const { t } = useTranslation();
  const { isOpenModal, onCloseModal, payload = {} } = useModal(MODAL_NAME_AUTH);
  const { selectedAuthStateType } = payload as AuthModalPayloadType;
  const [authStateType, setAuthStateType] = useState<AuthStateType>(selectedAuthStateType || LOGIN_STATE_TYPE);

  if (authStateType === RESET_PASSWORD_STATE_TYPE) {
    return (
      <Dialog open={isOpenModal} onOpenChange={onCloseModal}>
        <DialogContent className="w-[90vw] max-w-md">
          <DialogHeader>
            <DialogTitle>{t('auth.resetPassword')}</DialogTitle>
          </DialogHeader>
          <ResetPasswordContainer onCloseModal={onCloseModal} />
          <button
            type="button"
            onClick={() => setAuthStateType(LOGIN_STATE_TYPE)}
            className="text-sm text-blue-500 hover:text-blue-700 underline"
          >
            {t('auth.backToLogin')}
          </button>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isOpenModal} onOpenChange={onCloseModal}>
      <DialogContent className="w-[90vw] max-w-md">
        <DialogHeader>
          <DialogTitle>
            {authStateType === LOGIN_STATE_TYPE ? t('auth.login') : t('auth.register')}
          </DialogTitle>
        </DialogHeader>
        <Tabs value={authStateType} onValueChange={(v) => setAuthStateType(v as AuthStateType)}>
          <TabsList className="w-full mb-4">
            <TabsTrigger value={LOGIN_STATE_TYPE} className="flex-1">{t('auth.login')}</TabsTrigger>
            <TabsTrigger value={REGISTER_STATE_TYPE} className="flex-1">{t('auth.register')}</TabsTrigger>
          </TabsList>
          <TabsContent value={LOGIN_STATE_TYPE}>
            <LoginContainer
              onCloseModal={onCloseModal}
              onSwitchToResetPassword={() => setAuthStateType(RESET_PASSWORD_STATE_TYPE)}
            />
          </TabsContent>
          <TabsContent value={REGISTER_STATE_TYPE}>
            <RegisterContainer onCloseModal={onCloseModal} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModalContainer;
